import type { InOutType, InputParameter } from '@repositories/subscriptionConnectionRepository/subscriptionConnection.types';
import type { ExpressionType } from '@repositories/workflowRepository/workflow.types';
import type { MapInputData, SimpleInputData } from '@type/Common';

export class InputParameterModel {
  private readonly _dto: InputParameter;
  private _value: SimpleInputData;
  private _jsonSchemaValue: MapInputData;
  private _expressionType: ExpressionType;

  constructor(dto: InputParameter) {
    this._dto = dto;
    this._value = dto.value || {
      format: '',
    };
    this._jsonSchemaValue = {
      actionSource: {
        step: -1,
      },
      inputList: [],
    };
    this._expressionType = dto.expressionType || 'SIMPLE';
  }

  get originDTO(): InputParameter {
    return this._dto;
  }

  get expressionType() {
    return this._expressionType;
  }

  setExpressionType(type: ExpressionType) {
    this._expressionType = type;
  }

  get jsonSchemaValue() {
    return this._jsonSchemaValue;
  }

  setJsonSchemaValue(value: MapInputData) {
    this._jsonSchemaValue = value;
  }

  get value() {
    return this._value;
  }

  get description() {
    return this._dto.description || '';
  }

  get inputType(): InOutType {
    return this._dto.inputType || 'STRING';
  }

  get name() {
    return this._dto.name || '';
  }

  get displayName() {
    return this._dto.displayName || '';
  }

  get isRequired() {
    return this._dto.isRequired || false;
  }

  get jsonSchema() {
    return this._dto.jsonSchema || '';
  }

  setValue(value: SimpleInputData) {
    this._value = value;
  }

  get resourceType() {
    return this._dto.resourceType || '';
  }
}
